module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./indexFuiouView.js"));
	}, "PayFormFuiouView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=PayFormFuiouView!./src/pages/Shop/PayMent/PayForm/indexFuiouView.js
// module id = 893
// module chunks = 431